var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopyOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "copy-orange_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 22 22",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".copy-orange_svg__st0{fill:none;stroke:#fafafa;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy-orange_svg__Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "copy-orange_svg__New-Messenger-Ads-1",
    transform: "translate(-270 -725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "copy-orange_svg__copy-_x28_2_x29_-copy",
    transform: "translate(271 726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "copy-orange_svg__Rectangle",
    className: "copy-orange_svg__st0",
    d: "M9 7h9c1.1 0 2 .9 2 2v9c0 1.1-.9 2-2 2H9c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "copy-orange_svg__Path",
    className: "copy-orange_svg__st0",
    d: "M3 13H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h9c1.1 0 2 .9 2 2v1"
  }))))));
}

export default __webpack_public_path__ + "./fonts/copy-orange.5d3cd6f58d791e91f2bd32958665dc7f.svg";
export { SvgCopyOrange as ReactComponent };